import React, { Component} from "react";
import { withRouter } from "react-router-dom";
import {Footer, Header, LastSection} from "../components";

class AboutUs extends Component{
	componentDidMount() {
		window.scrollTo(0,0);
	}
	render () {
		return(
			<div>
				<Header />
				<div className="container direction-rtl mb-5">
					<div className="row faqpage-container">
						<h1 className="pb-4 text-right faq-page-title pl-0">
							درباره ما
						</h1>
						<div className="col-12 text-right faq-detail text-justify">
							مپسا یه اپلیکیشن رایگان برای حسابداری و مدیریت پروژه است و مخفف عبارت مدیریت پروژه‌های ساختمانی ایران می باشد. این اپلیکیشن با هدف کمک به مدیران پروژه‌های ساختمانی و عمرانی در مدیریت مالی و عملیاتی پروژه ها، ایجاد و به صورت رایگان در دسترس عموم قرار گرفته است. کارکردن با نرم افزار مپسا بسیار ساده بوده و نیاز به داشتن تخصص خاصی ندارد.
						</div>
					</div>
				</div>
				<LastSection/>
				<Footer />
			</div>
		);
	}
}

export default withRouter(AboutUs);